import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { NoticeMessageState } from "stores/atoms/noticeMessageState";

import { AppHelper } from "helpers/appHelper";

/**
 * メッセージ通知コンポーネント
 */
export default function NotificationMessage(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */
  type MessageType = {
    message: string;
    status: string;
    time: number;
  };
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [noticeMessageState] = useRecoilState(NoticeMessageState);

  const [messages, setMessages] = useState([]);
  const [timer, setTimer] = useState(0);

  // メッセージの表示時間
  const noticeMessageDisplayMs = 3000;
  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  useEffect(() => {
    (async () => {
      if (AppHelper.isEmpty(noticeMessageState.message)) {
        return;
      }
      setMessages([
        ...messages,
        { ...noticeMessageState, time: new Date().getTime() },
      ]);
      setTimeout(
        function () {
          setTimer(new Date().getTime());
        }.bind(this),
        noticeMessageDisplayMs
      );
    })();
  }, [noticeMessageState]);

  useEffect(() => {
    const newMessages: MessageType[] = [];
    messages.forEach((item) => {
      if (timer - item.time < noticeMessageDisplayMs) newMessages.push(item);
    });
    setMessages(newMessages);
  }, [timer]);

  const clearMessages = (message: MessageType) => {
    const newMessages = messages.filter((item) => item !== message);
    setMessages(newMessages);
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <div className="notification-message">
        {messages.map((item) => {
          return (
            <p
              key={item.time}
              onClick={() => clearMessages(item)}
              className={`btn-xmark ms-5 ${item.status}`}
            >
              {item.message}
            </p>
          );
        })}
      </div>
    </>
  );
}
